import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { ApiService, NotificationService } from '../../../../../core/core.module';

@Component({
  selector: 'mydyn-bottomsheetuploaddocumento',
  templateUrl: 'bottomSheetUploadDocumento.component.html',
  styleUrls: ['./bottomSheetUploadDocumento.component.scss']
})
export class BottomSheetUploadDocumentoComponent {
  appLoading = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { tipoDocumento: number; idPratica: number },
    private bottomSheetRef: MatBottomSheetRef<BottomSheetUploadDocumentoComponent>,
    private apiService: ApiService,
    private notificationService: NotificationService
  ) {}

  fileSelected(event: Event) {
    if (event) {
      if (
        ['.pdf', '.jpeg', '.jpg', '.png', '.gif'].includes(
          (event.target as HTMLInputElement).files[0].name.slice(
            (event.target as HTMLInputElement).files[0].name.lastIndexOf('.')
          )
        )
      ) {
        this.bottomSheetRef.disableClose = true;
        this.appLoading = true;
        this.blobToBase64((event.target as HTMLInputElement).files[0]).then((base64Document) => {
          this.apiService
            .uploadDocumentoPraticaDaApp(
              {
                titolo: (event.target as HTMLInputElement).files[0].name,
                tipo: this.data.tipoDocumento,
                documento: base64Document.slice(base64Document.indexOf(',') + 1)
              },
              this.data.idPratica
            )
            .subscribe((response) => {
              this.bottomSheetRef.dismiss(response);
              event.preventDefault();
              if (response) {
                this.notificationService.success('Documento caricato');
              } else {
                this.notificationService.error('Errore durante il caricamento del documento');
              }
              this.appLoading = false;
            });
        });
      } else {
        this.bottomSheetRef.dismiss(false);
        event.preventDefault();
        this.notificationService.error('Formato documento non supportato');
      }
    }
  }

  blobToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise<string>((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result.toString());
      };
    });
  };
}
